export default "__VITE_ASSET__BvXNNFgB__"